import { render, staticRenderFns } from "./reisetermine-overview.vue?vue&type=template&id=2229614b&scoped=true"
import script from "./reisetermine-overview.vue?vue&type=script&lang=js"
export * from "./reisetermine-overview.vue?vue&type=script&lang=js"
import style0 from "./reisetermine-overview.vue?vue&type=style&index=0&id=2229614b&prod&lang=scss&scoped=true"
import style1 from "./reisetermine-overview.vue?vue&type=style&index=1&id=2229614b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229614b",
  null
  
)

export default component.exports